import { gql } from 'urql';

export const NOVEDAD_FIELDS = gql`
  fragment NovedadFields on Novedad {
    id
    sucursalId
    guiaId
    repartoId
    repartoGuiaId
    motivoId
    estado
    detalle
    evidenciaJson
    fechaEvento
    creadoPorUsuarioId
    createdAt
    updatedAt
  }
`;

export const NOVEDADES_MOTIVOS_QUERY = gql`
  query NovedadesMotivos($activo: Boolean, $categoria: String, $search: String) {
    novedadesMotivos(activo: $activo, categoria: $categoria, search: $search) {
      id
      codigo
      nombre
      categoria
      requiereDetalle
      activo
    }
  }
`;

export const NOVEDADES_BY_SUCURSAL_QUERY = gql`
  ${NOVEDAD_FIELDS}
  query NovedadesBySucursal($sucursalId: ID!, $estado: String, $desde: DateTime, $hasta: DateTime, $lineaId: ID, $choferId: ID) {
    novedadesBySucursal(
      sucursalId: $sucursalId
      estado: $estado
      desde: $desde
      hasta: $hasta
      lineaId: $lineaId
      choferId: $choferId
    ) {
      ...NovedadFields
    }
  }
`;

export const NOVEDAD_DETALLE_QUERY = gql`
  query NovedadDetalle($id: ID!) {
    novedadDetalle(id: $id) {
      novedad { id estado detalle fechaEvento guiaId motivoId evidenciaJson }
      historial { id accion beforeJson afterJson usuarioId createdAt }
    }
  }
`;

export const MONITOR_NOVEDADES_QUERY = gql`
  query MonitorNovedades($sucursalId: ID!) {
    monitorNovedades(sucursalId: $sucursalId) {
      pendientes
      retenidas
      reprogramadas
      resueltasHoy
    }
  }
`;

export const CREATE_NOVEDAD_MUTATION = gql`
  ${NOVEDAD_FIELDS}
  mutation CreateNovedad($input: CreateNovedadInput!) {
    createNovedad(input: $input) {
      ...NovedadFields
    }
  }
`;

export const UPDATE_NOVEDAD_MUTATION = gql`
  ${NOVEDAD_FIELDS}
  mutation UpdateNovedad($id: ID!, $input: UpdateNovedadInput!) {
    updateNovedad(id: $id, input: $input) {
      ...NovedadFields
    }
  }
`;

export const RESOLVER_NOVEDAD_MUTATION = gql`
  ${NOVEDAD_FIELDS}
  mutation ResolverNovedad($novedadId: ID!, $detalle: String) {
    resolverNovedad(novedadId: $novedadId, detalle: $detalle) {
      ...NovedadFields
    }
  }
`;

export const REPROGRAMAR_GUIA_MUTATION = gql`
  ${NOVEDAD_FIELDS}
  mutation ReprogramarGuia($guiaId: ID!, $detalle: String, $fechaProximoIntento: DateTime) {
    reprogramarGuia(guiaId: $guiaId, detalle: $detalle, fechaProximoIntento: $fechaProximoIntento) {
      ...NovedadFields
    }
  }
`;
